import { type Meta } from '../types/docs';
import {
  AUTOMATION_RUNS_LIST_OPENED_LOCATIONS,
  AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM,
} from './automationsAnalytics';

const META: Meta = {
  description: 'The user opens the list of runs for an automation',
  name: 'automation_runs_list_opened',
  params: [
    AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'The automation whose runs are shown',
      name: 'automation_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Where the runs list was opened from',
      name: 'location',
      required: true,
      type: 'enum',
      values: [...AUTOMATION_RUNS_LIST_OPENED_LOCATIONS],
    },
  ],
};

export default META;
